import { helper } from '@ember/component/helper';
import { DataCenter } from 'cio/models/account';

export const DATACENTER_FLAGS = {
  [DataCenter.US]: '🇺🇸',
  [DataCenter.EU]: '🇪🇺',
};

const DATACENTER_NAMES = {
  [DataCenter.US]: (_: boolean) => 'United States',
  [DataCenter.EU]: (adjective: boolean) => (adjective ? 'European' : 'Europe'),
};

export function dataCenterName(
  [dataCenter]: [DataCenter],
  { adjective = false, showFlag = true }: { adjective: boolean; showFlag: boolean },
) {
  let name = DATACENTER_NAMES[dataCenter](adjective);

  if (showFlag) {
    let flag = DATACENTER_FLAGS[dataCenter] ?? '';
    return `${flag} ${name}`;
  } else {
    return name;
  }
}

export default helper(dataCenterName);
